import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from 'hooks/useAuth/useAuth';
import { KM_TO_MILES } from 'utils/constants/formats';

const Distance = ({ className, distance }) => {
  const { profile } = useAuth();

  const convertKmToMi = useCallback(dist => {
    return Math.round(dist * KM_TO_MILES);
  }, []);

  const renderDistance = useCallback(() => {
    if (profile?.user?.country_settings?.units?.distance === 'mi') {
      return <>{`${convertKmToMi(distance)} Mi`}</>;
    } else {
      return <>{`${distance} Km`}</>;
    }
  }, [profile, convertKmToMi, distance]);

  return (
    <div className={className} data-testid="distance">
      <div className="distance">{renderDistance()}</div>
    </div>
  );
};

Distance.defaultProps = {
  className: ''
};

Distance.propTypes = {
  className: PropTypes.string,
  distance: PropTypes.number.isRequired
};

export default Distance;
